var $ = jQuery;

function updateCommentsAccordion() {
	// <%-- Expandable comments section. --%>
	if ($("#comments-accordion").length) {
		$("#comments-accordion").accordion({
			active:false,
			collapsible: true
		});
	}			
}

module.exports = updateCommentsAccordion;